import { createIdentifier } from '@toeverything/infra';

import type { DocRecord } from '../entities/record';
import type { DocCreateOptions } from '../types';

export interface DocCreateMiddleware {
  beforeCreate?: (docCreateOptions: DocCreateOptions) => DocCreateOptions;
  beforeLocalVisibility?: (
    docId: string,
    docCreateOptions: DocCreateOptions
  ) => void;
  afterCreate?: (doc: DocRecord, docCreateOptions: DocCreateOptions) => void;
  onCreateRejected?: (
    docId: string,
    docCreateOptions: DocCreateOptions,
    error: Error
  ) => void;
}

export const DocCreateMiddleware = createIdentifier<DocCreateMiddleware>(
  'DocCreateMiddleware'
);
